const HEADERS = ["Source Language", "Target Language", "Number of Prices"];

const VendorLanguagePairsTable = ({ languagePairs = [], worksWithAll = false }) => {
  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden">
      <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
        <table className="w-full table-auto border-collapse">
          <thead className="sticky top-0 z-10">
            <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
              {HEADERS.map((h) => (
                <th
                  key={h}
                  className="px-3 py-2 text-center font-semibold whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {languagePairs.length === 0 ? (
              <tr>
                <td
                  colSpan={HEADERS.length}
                  className="py-10 text-center text-gray-400 text-xs"
                >
                  {worksWithAll
                    ? "No language pairs configured by admin yet."
                    : "No language pairs selected. Click 'Update' to choose pairs."}
                </td>
              </tr>
            ) : (
              languagePairs.map((pair, index) => {
                const rowBg = index % 2 === 0 ? "bg-gray-50" : "bg-white";
                return (
                  <tr
                    key={pair.id || index}
                    className={`${rowBg} hover:bg-blue-50 transition-colors`}
                  >
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900">
                      {pair.sourceLanguage?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900">
                      {pair.targetLanguage?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {pair.price_count || 0}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorLanguagePairsTable;
